import api from "./api";

const getMasterDataActionLog = (search) => {
  return api
    .get("/masterdataactionlog", {
      params: {
        ...search,
      },
    })
    .then((response) => {
      return response.data;
    });
};

const getMasterDataActionLogElement = (id) => {
  return api.get("/masterdataactionlog/" + id).then((response) => {
    return response.data;
  });
};

const createMasterDataActionLog = (masterDataActionLog) => {
  return api.post("/masterdataactionlog", {
    ...masterDataActionLog,
  });
};

const updateMasterDataActionLog = (masterDataActionLog) => {
  return api
    .patch("/masterdataactionlog", {
      ...masterDataActionLog,
    })
    .then((response) => {
      return response.data;
    });
};

const getMasterDataActionLogFilterValues = (search) => {
  return api
    .get("/masterdataactionlog/filtervalues", {
      params: {
        ...search,
      },
    })
    .then((response) => {
      return response.data;
    });
};

const getMasterDataActionLogUi = () => {
  return api.get("/masterdataactionlog/ui").then((response) => {
    return response.data;
  });
};

const MasterDataActionLogService = {
  getMasterDataActionLog,
  getMasterDataActionLogElement,
  createMasterDataActionLog,
  updateMasterDataActionLog,
  getMasterDataActionLogFilterValues,
  getMasterDataActionLogUi,
};

export default MasterDataActionLogService;
